export const DEFAULT_COPY_BUTTON_LABEL = 'Copy code to clipboard'
